// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Layout4_wrapper__3XwzK","user":"Layout4_user__1Mfy-","mainUser":"Layout4_mainUser__1b621","topRow":"Layout4_topRow__3PDlM","bottomRow":"Layout4_bottomRow__3UmRN"};